import React, { Component } from "react";
import Table from "./../common/table";
import { Link, withRouter } from "react-router-dom";
import moment from "moment"

class SupervisorsTable extends Component {
	
	handleSelectAll = (e) => {
		const { checked } = e.target;
		const { supervisors } = this.props;
		
		if (checked) {
			// Select all supervisors
			const allIds = supervisors.map(supervisor => supervisor._id);
			this.props.onSelectAll(allIds);
		} else {
			// Deselect all
			this.props.onSelectAll([]);
		}
	};

	isAllSelected = () => {
		const { supervisors, checkedFields = [] } = this.props;
		return supervisors.length > 0 && supervisors.every(supervisor => 
			checkedFields.includes(supervisor._id)
		);
	};

	getColumns = () => [
		{
			key: "checkbox",
			label: (
				<input
					type="checkbox"
					style={{
						width: "15px",
						height: "15px",
						marginTop: "0.4rem",
						borderRadius: 0,
					}}
					onChange={this.handleSelectAll}
					checked={this.isAllSelected()}
				/>
			),
			content: (supervisor) => (
				<span className="icon-img sm-r-5" style={{ marginTop: "15px" }}>
					<input
						type="checkbox"
						style={{
							width: "15px",
							height: "15px",
							marginTop: "0.4rem",
							borderRadius: 0,
						}}
						onChange={this.props.handleCheckboxChange}
						value={supervisor._id}
						checked={this.props.checkedFields?.includes(supervisor._id) || false}
					/>
				</span>
			),
		},
		{
			key: "avatarUsername",
			label: "Username",
			content: (supervisor) => (
				<div style={{ display: "flex", alignItems: "center" }}>
					<img
						src={supervisor.supervisors?.imageSrc || supervisor.supervisors?.imageSrc || supervisor.imageSrc || '/default-avatar.png'}
						alt="Avatar"
						style={{ width: "30px", height: "30px", borderRadius: "50%", marginRight: "10px" }}
						onError={(e) => {
							e.target.src = '/default-avatar.png';
						}}
					/>
					<span>{supervisor.supervisors?.username || supervisor.supervisors?.username || supervisor.username || 'N/A'}</span>
				</div>
			),
		},
		{
			label: 'Email',
			path: 'supervisors.email'
		},
		{
			label: 'First Name',
			path: 'supervisors.contactName.first'
		},
		{
			label: 'Initials',
			path: 'supervisors.contactName.initials'
		},
		{
			label: 'Last Name',
			path: 'supervisors.contactName.last'
		},
		{
			label: 'Gender',
			path: 'supervisors.gender'
		},
		{
			label: 'Date of Birth',
			key: 'dateBirth',
			content: (supervisor) => {
				const dob = supervisor.supervisors?.dateBirth;
				return dob ? moment(dob).format('MM/DD/YYYY') : '';
			}
		},
		{
			label: 'Address',
			key: 'address',
			content: (supervisor) => {
				const addr = supervisor.supervisors?.Address;
				if (!addr) return '';
				const parts = [addr.address1, addr.city, addr.state].filter(Boolean);
				return parts.join(', ');
			}
		},
		{
			label: 'Zip',
			path: 'supervisors.Address.zip'
		},
		{
			label: 'Country',
			path: 'supervisors.Address.country'
		},
		{
			label: 'Mobile',
			path: 'supervisors.phones.mobile'
		},
		{
			label: 'Phone',
			path: 'supervisors.phones.phone'
		},
		{
			label: 'Skype',
			path: 'supervisors.phones.skype'
		},
		{
			label: 'Status',
			key: 'status',
			content: (supervisor) => (
				<span className={`badge ${supervisor.status === 'active' ? 'badge-success' : 'badge-secondary'}`}>
					{supervisor.status || ''}
				</span>
			)
		},
		{
			label: 'Business Name',
			key: 'businessName',
			content: (supervisor) => {
				// Check if businessName exists and is not empty
				const businessName = supervisor.supervisors?.businessName || 
					   supervisor.supervisors?.businessName || 
					   supervisor.businessName || 
					   supervisor.companyInfo?.businessName || 
					   supervisor.supervisors?.companyInfo?.businessName;
				
				// If business name exists and is not empty, show it
				if (businessName && businessName.trim() !== '') {
					return businessName;
				}
				
				// If we have a businessNo but no populated business name, show a pending message
				if (supervisor.businessNo) {
					return <span className="text-muted">Pending Population</span>;
				}
				
				// No business association
				return 'N/A';
			}
		},
	];

	render() {
		const { supervisors, onSort, sortColumn, checkedFields } = this.props;
		const columns = this.getColumns();
		return (
			<Table
				columns={columns}
				sortColumn={sortColumn}
				onSort={onSort}
				data={supervisors}
			/>
		);
	}
}

export default SupervisorsTable;
